import { observer } from 'mobx-react-lite';
import { LuDot } from 'react-icons/lu';
import { API_BASE_URL } from '../../__common/env';
import RoundedButton from './RoundedButton';
import { IoIosStarOutline } from 'react-icons/io';
import { BsThreeDots } from 'react-icons/bs';
import { EditIcon, PdfIcon } from './Icon';
import { MdDeleteOutline } from 'react-icons/md';

const ProjectCard = observer(
    ({ name, projectId, handleOpenProject, confirmDelete }) => {
        return (
            <div
                onDoubleClick={(e) => handleOpenProject(projectId, e)}
                className="collapse-content border border-theme-border rounded-[16px] cursor-pointer overflow-hidden relative group">
                <div className="absolute top-[16px] px-[16px] flex items-center justify-between w-full">
                    <div className="relative w-[100px] h-[32px] ">
                        <button className="absolute inset-0 px-[16px] h-[32px] text-[12px] transition-opacity duration-300 ease-in-out leading-[24px] font-favorit text-theme-white bg-[rgba(0,0,0,0.8)] py-[4px] border border-theme-button-bg rounded-[36px] group-hover:opacity-0 z-10">
                            Blueprint
                        </button>
                        {/* Star button (hidden by default, shows on hover) */}
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out  z-20">
                            <RoundedButton
                                isActive={true}
                                icon={
                                    <IoIosStarOutline className="text-theme-white text-[20px]" />
                                }
                            />
                        </div>
                    </div>

                    {/* Three-dot menu button (optional: spaced out if needed) */}
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out flex z-10 ml-2">
                        {/* <RoundedButton
                        isActive={true}
                        onDoubleClick={(e) => e.stopPropagation()}
                        onclick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        className="hover:bg-theme-header-bg menu-button"
                        icon={
                            <BsThreeDots className="text-theme-white text-[20px] " />
                        }
                    /> */}
                        <RoundedButton
                            isActive={true}
                            onDoubleClick={(e) => e.stopPropagation()}
                            onClick={(e) => {
                                e.stopPropagation();
                                confirmDelete();
                            }}
                            className="hover:bg-theme-header-bg menu-button"
                            icon={
                                <MdDeleteOutline className="text-theme-white text-[20px] " />
                            }
                        />
                    </div>
                </div>

                <div className="absolute top-0 left-0 w-full h-[200px] bg-[rgba(0,0,0,0.5)] opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out z-0"></div>
                <img
                    src={`${API_BASE_URL}/assets/img/temp1.png`}
                    alt=""
                    className="w-full h-[200px] "
                />
                <div className="p-[16px] group-hover:bg-theme-header-bg">
                    <h1 className="text-[16px] font-favorit font-[700] leading-[24px]">
                        {name}
                    </h1>
                    <div className="flex items-center">
                        <span className="text-theme-stroke text-[14px] font-favorit leading-[24px]">
                            2 Units
                        </span>
                        <LuDot className="text-theme-stroke text-[24px]" />
                        <span className="text-theme-stroke text-[14px] font-favorit leading-[24px]">
                            2 Units
                        </span>
                    </div>
                </div>
            </div>
        );
    },
);

export default ProjectCard;

// const PopOverContent = observer(({ setIsOpen }) => {
//     const buttons = [
//         {
//             name: 'Edit',
//             icon: <EditIcon />,
//             onClick: () => setIsOpen(false),
//         },
//         {
//             name: 'Delete',
//             icon: <PdfIcon />,
//             onClick: () => setIsOpen(false),
//         },
//     ];
//     return (
//         <div>
//             <button onClick={() => setIsOpen(false)}>Close</button>
//         </div>
//     );
// });
